import {createWebHistory, createRouter} from "vue-router";
import routes from './routes';
import env from "@/env";
import store from "@/state/store";

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {top: 0, left: 0};
        }
    },
});

router.beforeEach(async (routeTo, routeFrom, next) => {
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
    const token = localStorage.getItem('token');

    if (!authRequired) {
        return next();
    }

    if (!token) {
        return next({ name: 'login' });
    }

    const loggedIn = store.getters['auth/loggedIn'];
    
    if (!loggedIn) {
        try {
            await store.dispatch('auth/initialize');
        } catch (error) {
            store.dispatch('auth/reset');
            return next({ name: 'login' });
        }
    }

    next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
    try {
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                if (route.meta && route.meta.beforeResolve) {
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        if (args.length) {
                            next(...args);
                            reject(new Error('Redirected'));
                        } else {
                            resolve();
                        }
                    });
                } else {
                    resolve();
                }
            });
        }
    } catch (error) {
        return;
    }

    document.title = (routeTo.meta?.title || '') + ' | ' + env.title;
    
    if (store.hasModule('api')) {
        store.commit('api/resetValues');
        store.commit('api/changeShowModalForm', false);
    }
    
    next();
});

export default router;
